module.exports = __webpack_public_path__ + "static/media/Lala_documenta14.c5f15b1d.jpg";